import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["checked", "required", "disabled"];
const __default__ = {
    compatConfig: { COMPONENT_V_MODEL: false }
};
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'CheckboxField',
    props: {
        disabled: { type: Boolean },
        hideLabel: { type: Boolean },
        label: null,
        modelValue: { type: Boolean },
        required: { type: Boolean }
    },
    emits: ['update:modelValue'],
    setup(__props, { emit }) {
        const props = __props;
        function handleInput() {
            emit('update:modelValue', !props.modelValue);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("label", null, [
                _renderSlot(_ctx.$slots, "default"),
                _createElementVNode("span", null, [
                    _createElementVNode("input", {
                        checked: __props.modelValue,
                        type: "checkbox",
                        required: __props.required,
                        disabled: __props.disabled,
                        class: "w-6 h-6 text-primary-500 form-checkbox",
                        onInput: handleInput
                    }, null, 40, _hoisted_1),
                    _createElementVNode("span", {
                        class: _normalizeClass(["text-sm text-gray-700 dark:text-gray-300", { 'sr-only': __props.hideLabel, 'ml-2': __props.label }])
                    }, _toDisplayString(__props.label), 3)
                ])
            ]));
        };
    }
});
